import { useState } from 'react';
import { Form, Input, Button, Col, Row, Typography, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import '../scss/login.scss'
import AuthService from '../utils/api/auth';
import MarketPlaceService from '../utils/api/marketplace';


export default function Login() {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false)
  let history = useNavigate();
  const [error, setError] = useState({
    status: false,
    msg: ''
  });

  const [inactiveAccount, setInactiveAccount] = useState(false)

  const msgError = () => {
    messageApi.open({
      type: 'error',
      content: 'Correo o contraseña incorrectos',
    });
  };

  const msgWarning = () => {
    messageApi.open({
      type: 'warning',
      content: 'Estamos verificando tu cuenta',
    });
  };


  const mergeGuestCart = async (userData) => {
    const guestCartKey = 'cart_guest';
    const pendingCartKey = 'pending_cart_items';

    try {
      let guestItems = [];
      let pendingItems = [];

      try {
        const guestCart = localStorage.getItem(guestCartKey);
        if (guestCart) {
          guestItems = JSON.parse(guestCart);
        }
      } catch (error) {
        guestItems = [];
      }
      try {
        const pendingCart = localStorage.getItem(pendingCartKey);
        if (pendingCart) {
          pendingItems = JSON.parse(pendingCart);
        }
      } catch (error) {
        pendingItems = [];
      }

      const allPendingItems = [...guestItems, ...pendingItems];
      if (!allPendingItems || allPendingItems.length === 0) return;

      let currentCart;
      try {
        currentCart = await MarketPlaceService.getCartByClient(userData.id);
      } catch (error) {
        currentCart = { data: null };
      }

      let productsInCart = [];
      if (currentCart?.data?.products && Array.isArray(currentCart.data.products)) {
        productsInCart = currentCart.data.products.filter(item =>
          item.user_id === userData.id && item.user_role === userData.role
        );
      }

      const mergedProducts = [...productsInCart];
      allPendingItems.forEach((item) => {
        const idx = mergedProducts.findIndex(prod =>
          prod.id === item.id || prod.product_id === item.id || prod.product_id === item.product_id
        );

        if (idx > -1) {
          mergedProducts[idx].quantity += Number(item.quantity || 1);
          mergedProducts[idx].price = Number(item.price) || mergedProducts[idx].price || 0;
        } else {
          mergedProducts.push({
            ...item,
            product_id: item.product_id || item.id,
            user_role: userData.role,
            user_id: userData.id
          });
        }
      });

      const totalPrice = mergedProducts.reduce((sum, item) =>
        sum + (Number(item.price) * Number(item.quantity)), 0
      );

      const cartData = {
        client_id: userData.id,
        client_role: userData.role,
        products: mergedProducts,
        price: totalPrice,
        change_type: 'MX',
        status: 1
      };

      if (currentCart?.data?.id) {
        await MarketPlaceService.updateCart(cartData, currentCart.data.id);
      } else {
        await MarketPlaceService.addProductToCart(cartData);
      }

      const cartKey = `cart_${userData.id}_${userData.role}`;
      localStorage.setItem(cartKey, JSON.stringify(mergedProducts));
      localStorage.removeItem(guestCartKey);
      localStorage.removeItem(pendingCartKey);
      window.dispatchEvent(new Event('cartUpdated'));
    } catch (error) {
      console.error('Error merging guest cart:', error);
    }
  };

  const onFinish = (values) => {
    setLoading(true);
    AuthService.LoginEpno(values)
      .then(async response => {
        if (response.data.status === false) {
          setInactiveAccount(true)
          msgWarning()
          setLoading(false);
        } else if (response.status === 200) {
          localStorage.setItem('role', response.data.role);
          const role = parseInt(response.data.role)
          localStorage.setItem('user', JSON.stringify(response.data));
          await mergeGuestCart(response.data);
          setLoading(false);
          const redirectPath = localStorage.getItem('post_login_redirect');
          if (redirectPath) {
            localStorage.removeItem('post_login_redirect');
            history(redirectPath);
            return;
          }
          if ((role === 1)) { // Admin
            history('/dashboard')
          } else if (role === 3) { // Compras
            history('/orders/all/1')
          } else if (role === 4) { // Industria (cliente)
            history(`/@p/${response.data.id}`)
          } else if (role === 5) { // Ventas
            history('/orders/all/1')
          } else if (role === 6) { // Proveedores
            history(`/@p/${response.data.id}`)
          } else if (role === 9) {
            history('/dashboard')
          }
        } else {
          setLoading(false);
        }
      })
      .catch(error => {
        console.log(error)
        setError({
          status: true,
          msg: 'Usuario y/o contraseña incorrectos'
        })
        msgError()
        setLoading(false);
      })
  }

  return (
    <Row className="login-row">
      {contextHolder}
      <img className="login-logo" src="/img/epno.png" alt="EP&O" />

      <Col xs={24} sm={12} className="login-hero-col">
        <div className="login-hero">
          <Typography.Title className="hero-title">
            TODO LO QUE TU ÁREA DE COMPRAS NECESITA EN UN SOLO LUGAR
          </Typography.Title>
          <Typography.Paragraph className="hero-subtitle">
            Conecta con proveedores confiables y optimiza tu proceso de adquisición
          </Typography.Paragraph>
          <img src='/img/dispositivos.png' width={'100%'} />
        </div>
      </Col>

      <Col xs={24} sm={12} className="login-form-col">
        <div className="login-form">
          <Typography.Title level={3} className="form-title">
            ¡BIENVENIDO A EP&O!
          </Typography.Title>
          <Typography.Paragraph className='form-subtitle'>Ingresa tu correo y contraseña para continuar</Typography.Paragraph>

          <Form
            form={form}
            name="login"
            layout="vertical"
            variant='filled'
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Ingresa tu correo electrónico' }]}
            >
              <Input placeholder="Correo electrónico" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Ingresa tu contraseña' }]}
            >
              <Input.Password placeholder="Contraseña" />
            </Form.Item>

            <Form.Item>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'right' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  variant='success'
                  color="cyan"
                  block
                  loading={loading}
                >
                  Iniciar sesión
                </Button>
              </div>
            </Form.Item>

            <div className="form-extra">
              <Link to="/reset">Recuperar contraseña</Link>
              <p>¿Aún no estás registrado? <Link to="/register" className="register-link">¡Únete a nosotros!</Link></p>

            </div>
          </Form>
        </div>
      </Col>
    </Row>

  );
}